import type { ChatCustomerAction } from "../types";

/** SMS-shaped outbound mirrors append cancel/receipt URLs; chat shows chips instead. */
const CANCEL_URL_RE =
  /https?:\/\/\S+\/(?:api\/v\d+\/)?webhooks\/cancel\/[A-Za-z0-9_-]+/;
const RECEIPT_URL_RE =
  /https?:\/\/\S+\/(?:api\/v\d+\/)?public\/booking-receipts\/\S+/;

/** Drop labeled cancel/receipt URL lines and return WhatsApp-style actions. */
export function forOutboundCustomerDisplay(content: string): {
  body: string;
  actions: ChatCustomerAction[];
} {
  const actions: ChatCustomerAction[] = [];
  const seen = new Set<string>();
  const bodyLines: string[] = [];

  for (const line of content.split("\n")) {
    const cancel = line.match(CANCEL_URL_RE)?.[0]?.replace(/[),.]+$/u, "");
    if (cancel) {
      if (!seen.has(cancel)) {
        seen.add(cancel);
        actions.push({ kind: "cancel", url: cancel });
      }
      continue;
    }
    const receipt = line.match(RECEIPT_URL_RE)?.[0]?.replace(/[),.]+$/u, "");
    if (receipt) {
      if (!seen.has(receipt)) {
        seen.add(receipt);
        actions.push({ kind: "receipt", url: receipt });
      }
      continue;
    }
    bodyLines.push(line);
  }

  if (actions.length === 0) {
    return { body: content, actions: [] };
  }

  return {
    body: bodyLines
      .join("\n")
      .replace(/\n{3,}/gu, "\n\n")
      .replace(/\s+$/u, ""),
    actions,
  };
}
